import React, { useEffect, useState } from "react";
import styles from "./ToggleSwitch.module.css";
import { useFocusHandling } from "../../../hooks";

interface ToggleSwitchProps {
  selected?: "off" | "on";
  state?: "default" | "disabled";
  onChange?: (selected: "off" | "on") => void;
  className?: string;
}

export const ToggleSwitch = ({
  className = "",
  selected: externalSelected = "off",
  state = "default",
  onChange,
}: ToggleSwitchProps) => {
  const [selected, setSelected] = useState(externalSelected);
  const [isFocused, setIsFocused] = useState(false);

  const handleClick = () => {
    if (state === "disabled") return;
    setSelected(selected === "off" ? "on" : "off");
    onChange?.(selected);
  };

  const { handleFocus, handleBlur } = useFocusHandling({
    isDisabled: state === "disabled",
    setHighlight: setIsFocused,
    onEnter: handleClick,
  });

  useEffect(() => {
    setSelected(externalSelected);
  }, [externalSelected]);

  return (
    <div
      className={[styles.root, className, "quill-ui-next-component"].join(" ")}
      data-selected={selected}
      data-state={state}
      onClick={handleClick}
      onFocus={handleFocus}
      onBlur={handleBlur}
      tabIndex={state !== "disabled" ? 0 : -1}
    >
      <div className={styles.knob}></div>
      {isFocused && <div className={styles.bgFocus}></div>}
    </div>
  );
};
